import React from "react";
import CourseCard from "../components/CourseCard";
import courses from "../data/courses"; // Import the courses data

function OurCourses() {
  return (
    <div className="relative">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center max-w-6xl mx-auto px-4 my-8 items-center bg-red-50 py-12">
        {courses.map((course) => (
          <CourseCard
            key={course.id}
            title={course.title}
            topics={course.topics}
            imageUrl={course.imageUrl}
            courseLink={course.courseLink}
          />
        ))}
      </div>
    </div>
  );
}

export default OurCourses;
